module.exports = __webpack_public_path__ + "static/media/male_avatar.d33c1b21.png";